import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail, Phone } from 'lucide-react';

const Footer = ({ onPrivacyClick, onImprintClick }) => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12 mt-12 sm:mt-20">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-emerald-400 mb-3 sm:mb-4">Brillanz & Glanz</h3>
            <p className="text-sm sm:text-base text-gray-400 mb-4">
              {t('footer.description', 'Premium Reinigungsdienstleistungen für Häuser, Büros, AirBNB-Immobilien, Restaurants und Hotels.')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">{t('footer.quickLinks', 'Schnelllinks')}</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={onPrivacyClick}
                  className="text-sm sm:text-base text-gray-400 hover:text-emerald-400 transition-colors duration-200"
                >
                  {t('footer.privacy', 'Datenschutzerklärung')}
                </button>
              </li>
              <li>
                <button 
                  onClick={onImprintClick}
                  className="text-sm sm:text-base text-gray-400 hover:text-emerald-400 transition-colors duration-200"
                >
                  {t('footer.imprint', 'Impressum')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">{t('footer.contact', 'Kontakt')}</h4>
            <div className="space-y-3">
              <a href="mailto:thaqi.kujtim@gmx.net" className="flex items-center text-sm sm:text-base text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 mr-2 flex-shrink-0" />
                <span className="break-all">thaqi.kujtim@gmx.net</span>
              </a>
              <a href="tel:+41767669430" className="flex items-center text-sm sm:text-base text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 mr-2 flex-shrink-0" />
                +41 76 766 94 30
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400">
            © {currentYear} Brillanz & Glanz. {t('footer.rights', 'Alle Rechte vorbehalten.')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;